import i18next from 'i18next';
import { z } from 'zod';
import { zodI18nMap } from 'zod-i18n-map';
// 导入中文语言包
import translation from 'zod-i18n-map/locales/zh-CN/zod.json';

// 配置 i18next
i18next.init({
  lng: 'zh-CN',
  resources: {
    'zh-CN': { zod: translation },
  },
});

// 设置 Zod 错误映射
z.setErrorMap(zodI18nMap);

export { z };
